if(!customElements.get('main-collection-list')){
    class MainCollectionList extends HTMLElement {
        constructor(){
            super();

            this.id = this.dataset.id;
            this.collectionCardWrapper = this.querySelector('.main-collection-list__card-wrapper');
        }

        connectedCallback(){
            this.onLoadPaginationSubscriber = PubSub.subscribe(PubSub.events.onLoadPagination, this.handleCollectionLoad.bind(this));
        }

        disconnectedCallback(){
            if(this.onLoadPaginationSubscriber && typeof this.onLoadPaginationSubscriber === 'function'){
                this.onLoadPaginationSubscriber();
            }
        }

        handleCollectionLoad({ data, callback }){
            if(data.type !== 'collection') return;
            
            this.pendingRequestUrl = data.url;
            const currentUrl = data.url || this.pendingRequestUrl;

            setTimeout(() => {
                this.renderContent({
                    requestUrl: `${currentUrl}`,
                    callback: this.loadContent({
                        callback: callback
                    })
                });
            }, 500);
        }

        renderContent({ requestUrl, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        loadContent({ callback }){
            return (html) => {
                const collectionList = html.querySelector(`.main-collection-list[data-id="${this.id}"]`);
                if(collectionList){
                    const collectionCardWrapper = collectionList.querySelector('.main-collection-list__card-wrapper');

                    if (collectionCardWrapper) {
                        Array.from(collectionCardWrapper.children).forEach(child => {
                            this.collectionCardWrapper.appendChild(child.cloneNode(true));
                        });
                    }

                    const autoPagination = html.querySelector('auto-pagination');
                    if(autoPagination){
                        const url = autoPagination.dataset.url;
                        callback(url);
                    }
                }
            }
        }
    }

    customElements.define('main-collection-list', MainCollectionList);
}